export default "__VITE_ASSET__CuW3mmon__"